import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6a290032"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_2 = { class: "p-inputgroup" }
const _hoisted_3 = { class: "p-inputgroup-addon p-col-5" }
const _hoisted_4 = { class: "p-inputgroup p-mt-3" }
const _hoisted_5 = { class: "p-inputgroup-addon p-col-5" }

import { computed, ref } from "vue";
import { useValidation } from "vue3-form-validation";
import { useCreateCategory } from "@/graphql/category/category.create";
import { activeActivity, subscriptionExpired } from "@/plugins/i18n";
import { useUpdateCategory } from "@/graphql/category/update.category";
import { trim } from "@/graphql/utils/utils";
import { Category, EAccessMenu } from "@/graphql/types";
import ImageCropper from "@/components/common/ImageCropper.vue";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import { canNavigateAnywhere, getAccess } from "@/utils/activity";


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryForm',
  props: {
    item: {},
    categories: {},
    src: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const { t } = useI18n();
const image = ref<File>(null);
const { form, validateFields, resetFields } = useValidation({
  label: {
    $value: "",
    $rules: [(n: string) => !n && ""],
  },
  parentId: {
    $value: 0,
    $rules: [(n: number) => !n && ""],
  },
  type: {
    $value: 0,
  },
  removeImage: {
    $value: false,
  },
});
const cropperRef = ref<any>(null);
const selectedCountry = ref<Category>(null);
const filteredCategories = ref<Category[]>([]);
const toast = useToast();
const acc = getAccess(EAccessMenu.Category);
const noRestriction = canNavigateAnywhere();
const notExpired = !subscriptionExpired();
const blocked = computed(() => {
  const hasItem = Boolean(props?.item);
  const canUpdate = (acc?.update || noRestriction) && notExpired && hasItem;
  const canCreate = (acc?.create || noRestriction) && notExpired && !hasItem;
  return !canUpdate && !canCreate;
});
const { loadCreation, submitCreation } = useCreateCategory(() => {
  image.value = null;
  selectedCountry.value = null;
  resetFields();
});
const { loadUpdate, submitUpdate } = useUpdateCategory((v: boolean) => {
  image.value = null;
  emit("update:modelValue", v);
});

function searchCountry(event: any) {
  const parents = props.categories.filter((c) => c.id !== props?.item?.id);
  if (!event.query.trim().length) {
    filteredCategories.value = parents;
  } else {
    filteredCategories.value = parents.filter((cat: Category) => {
      return cat.label.toLowerCase().includes(event.query.toLowerCase());
    });
  }
}
if (props.item) {
  form.label.$value = String(props.item.label);
  selectedCountry.value = props.categories.find(
    (c) => c.id === props.item.parentId
  );
}

const onSubmit = () => {
  form.parentId.$value = selectedCountry.value?.id;
  validateFields().then(async (input) => {
    await cropperRef.value.getResult();
    trim(input);
    const exist = props.categories.find(
      (c) => c.label.toLowerCase() === form.label.$value.toLowerCase()
    );
    const { removeImage, ...res } = input;
    if (exist) {
      if (props.item) {
        if (props.item.id !== exist.id) {
          toast.add({
            severity: "info",
            summary: t("create.title"),
            detail: t(`category.exist`),
            life: Number(process.env.VUE_APP_TOAST_LIFE),
          });
        } else {
          submitUpdate(image.value, {
            id: props.item.id,
            ...input,
          });
        }
      } else {
        toast.add({
          severity: "info",
          summary: t("create.title"),
          detail: t(`category.exist`),
          life: Number(process.env.VUE_APP_TOAST_LIFE),
        });
      }
    } else if (props.item) {
      submitUpdate(image.value, {
        id: props.item.id,
        ...input,
      });
    } else {
      submitCreation(image.value, {
        ...res,
        activityId: activeActivity.value.id,
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Card = _resolveComponent("Card")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_component_BlockUI, { blocked: blocked.value }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        (!_ctx.item)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_1, _toDisplayString(_ctx.$t("category.create.title")), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_Card, { class: "p-shadow-0" }, {
          header: _withCtx(() => [
            _createVNode(ImageCropper, {
              ref_key: "cropperRef",
              ref: cropperRef,
              src: _unref(form).removeImage.$value ? '' : _ctx.src,
              modelValue: image.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((image).value = $event))
            }, {
              default: _withCtx(() => [
                (_ctx.item && !_unref(form).removeImage.$value)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-warning p-ml-3",
                      icon: "pi pi-times",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(form).removeImage.$value = true))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["src", "modelValue"])
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("category.parent")), 1),
              _createVNode(_component_AutoComplete, {
                "force-selection": true,
                modelValue: selectedCountry.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedCountry).value = $event)),
                suggestions: filteredCategories.value,
                "complete-on-focus": "",
                onComplete: _cache[3] || (_cache[3] = ($event: any) => (searchCountry($event))),
                dropdown: true,
                field: "label",
                "scroll-height": "150px",
                class: _normalizeClass({ 'p-invalid': _unref(form).parentId.$hasError })
              }, null, 8, ["modelValue", "suggestions", "class"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("category.name")), 1),
              _createVNode(_component_InputText, {
                modelValue: _unref(form).label.$value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).label.$value) = $event)),
                class: _normalizeClass({ 'p-invalid': _unref(form).label.$hasError }),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(form).label.$validate()))
              }, null, 8, ["modelValue", "class"])
            ])
          ]),
          footer: _withCtx(() => [
            (_ctx.item)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "submit",
                  label: _ctx.$t('save'),
                  icon: "pi pi-save",
                  disabled: _unref(loadUpdate),
                  loading: _unref(loadUpdate)
                }, null, 8, ["label", "disabled", "loading"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  type: "submit",
                  label: _ctx.$t('add'),
                  icon: "pi pi-plus",
                  disabled: _unref(loadCreation),
                  loading: _unref(loadCreation)
                }, null, 8, ["label", "disabled", "loading"]))
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }, 8, ["blocked"]))
}
}

})